import { config } from "../environment/config";

export const V4_API_PREFIX = "api/v4";

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;

export const DEFAULT_SORT_BY = "createdAt";
export const DEFAULT_SORT_BY_ID= "_id";

export enum SortOrder {
    ASC = "asc",
    DESC = "desc",
}

export const DEFAULT_SORT_ORDER = SortOrder.DESC;

// Presigned URL endpoints
export const PRESIGNED_URL_ENDPOINTS = {
  GENERATE: `/${V4_API_PREFIX}/cms/presigned-url`,
} as const;

// S3 configuration
export const S3_CONFIG = {
  BASE_URL: config.s3BaseUrl,
} as const;